import { Rect } from 'react-konva'
import { BaseElementBounds, Joist2D } from '../../../models/Construction'
import { BaseComponentProps, BaseElementWrapper } from './EditorWrapper'
import { ElementInteractionCallbacks, FLOOR_PLAN_COLORS } from './Elements'

interface JoistComponentProps extends BaseComponentProps<Joist2D> {}

export const JoistComponent: React.FC<JoistComponentProps> = ({
  element,
  scale,
  thicknessMultiplier = 1,
  isSelected = false,
  isHovered = false,
  onSelect,
  onDelete,
  onUpdate,
  onResizeStart,
}) => {
  const centerX = element.center_point.x * scale
  const centerY = element.center_point.y * scale
  const length = element.length * scale
  const width = element.thickness * scale * thicknessMultiplier
  const angle = element.rotation_z || 0

  const bounds: BaseElementBounds = {
    centerX,
    centerY,
    width: length,
    height: width,
    angle,
  }

  const callbacks: ElementInteractionCallbacks<Joist2D> = {
    onSelect,
    onDelete,
    onUpdate,
    onResizeStart,
  }

  const customColors = {
    normal: FLOOR_PLAN_COLORS.JOISTS,
    hover: '#D2B48C',
  }

  return (
    <BaseElementWrapper
      element={element}
      bounds={bounds}
      scale={scale}
      isSelected={isSelected}
      isHovered={isHovered}
      callbacks={callbacks}
      customColors={customColors}
      elementType='joist'
    >
      {({ styling, behaviors, dragProps }) => (
        <Rect
          x={centerX}
          y={centerY}
          width={length}
          height={width}
          offsetX={length / 2}
          offsetY={width / 2}
          rotation={angle}
          {...styling}
          {...dragProps}
          onClick={behaviors.handleClick}
          onTap={behaviors.handleClick}
          onMouseEnter={behaviors.handleMouseEnter}
          onMouseLeave={behaviors.handleMouseLeave}
        />
      )}
    </BaseElementWrapper>
  )
}
